/**
 * Cart Offer Section – Theme-Based Single Deal
 * Denver Leather Craft Theme
 */
(function () {
  'use strict';

  function initCartOfferSection() {
    var dataEl = document.getElementById('ct-popup-data');
    if (!dataEl) return;

    var configData;
    try {
      configData = JSON.parse(dataEl.textContent || '{}');
    } catch (e) {
      console.error('Failed to parse Cart Offer Section config:', e);
      return;
    }

    if (!configData || !configData.enabled) return;

    var threshold = parseInt(configData.threshold, 10) || 10000; // in cents
    var selectedGender = 'male';
    try {
      var savedGender = sessionStorage.getItem('ct_selected_gender');
      if (savedGender === 'male' || savedGender === 'female') {
        selectedGender = savedGender;
      }
    } catch (e) { }
    var isSubmitting = false;
    var wasOfferInCart = false;
    var currentCartState = null;
    var isAutoRemovingOffer = false;

    /**
     * Check if a specific cart item is the threshold offer product (male or female deal)
     */
    function isOfferItem(item) {
      if (!item) return false;
      var male = configData.male || {};
      var female = configData.female || {};

      var maleVarId = male.variantId ? String(male.variantId) : '';
      var maleProdId = male.productId ? String(male.productId) : '';
      var maleHandle = (male.handle || '').toLowerCase().trim();

      var femaleVarId = female.variantId ? String(female.variantId) : '';
      var femaleProdId = female.productId ? String(female.productId) : '';
      var femaleHandle = (female.handle || '').toLowerCase().trim();

      var itemVarId = item.variant_id ? String(item.variant_id) : (item.id ? String(item.id) : '');
      var itemProdId = item.product_id ? String(item.product_id) : '';
      var itemHandle = (item.handle || '').toLowerCase().trim();
      var itemUrl = (item.url || '').toLowerCase();

      // Check variant ID
      if (maleVarId && itemVarId && itemVarId === maleVarId) return true;
      if (femaleVarId && itemVarId && itemVarId === femaleVarId) return true;

      // Check product ID
      if (maleProdId && itemProdId && itemProdId === maleProdId) return true;
      if (femaleProdId && itemProdId && itemProdId === femaleProdId) return true;

      // Check product handle
      if (maleHandle && itemHandle && itemHandle === maleHandle) return true;
      if (femaleHandle && itemHandle && itemHandle === femaleHandle) return true;

      // Check URL fallback for handle
      if (maleHandle && itemUrl && itemUrl.indexOf('/' + maleHandle) !== -1) return true;
      if (femaleHandle && itemUrl && itemUrl.indexOf('/' + femaleHandle) !== -1) return true;

      return false;
    }

    /**
     * Get all offer items currently in the cart
     */
    function getOfferItemsInCart(cart) {
      if (!cart || !cart.items || !cart.items.length) return [];
      return cart.items.filter(isOfferItem);
    }

    /**
     * Check if male or female offer product is currently in the cart
     */
    function isOfferProductInCart(cart) {
      return getOfferItemsInCart(cart).length > 0;
    }

    /**
     * Calculate qualifying cart subtotal excluding the mystery box / offer products
     */
    function getQualifyingSubtotal(cart) {
      if (!cart || !cart.items || !cart.items.length) return 0;

      var subtotal = typeof cart.items_subtotal_price !== 'undefined'
        ? cart.items_subtotal_price
        : (cart.total_price || 0);

      var offerTotal = 0;
      cart.items.forEach(function (item) {
        if (isOfferItem(item)) {
          var linePrice = (typeof item.final_line_price !== 'undefined')
            ? item.final_line_price
            : ((typeof item.line_price !== 'undefined')
              ? item.line_price
              : ((item.price || 0) * (item.quantity || 1)));
          offerTotal += linePrice;
        }
      });

      var qualifying = subtotal - offerTotal;
      return qualifying > 0 ? qualifying : 0;
    }

    /**
     * Format money helper
     */
    function formatMoney(cents) {
      if (typeof cents === 'string') cents = parseFloat(cents);
      if (isNaN(cents)) return '';
      if (window.theme && window.theme.Helpers && typeof window.theme.Helpers.formatMoney === 'function') {
        var fmt = (window.theme.money_format || '${{amount}}');
        if (typeof fmt === 'string') fmt = fmt.replace(/\s*[A-Z]{3}\b/g, '').trim();
        return window.theme.Helpers.formatMoney(cents, fmt)
          .replace(/<[^>]*>/g, '')
          .replace(/\s*[A-Z]{3}\s*$/g, '')
          .trim();
      }
      return '$' + (cents / 100).toFixed(2);
    }

    /**
     * Update product details across all offer sections in the DOM
     */
    function updateProductDOM(gender) {
      var data = configData[gender];
      if (!data) return;

      var roots = document.querySelectorAll('[data-ct-offer-root]');
      roots.forEach(function (root) {
        var item = root.querySelector('[data-ct-gender="' + gender + '"]');
        if (!item) return;

        // Title
        var titleEl = item.querySelector('.js-ct-title-' + gender);
        if (titleEl && data.productTitle) {
          titleEl.textContent = data.productTitle;
          titleEl.setAttribute('title', data.productTitle);
        }

        // Image
        var imgEl = item.querySelector('.js-ct-img-' + gender);
        var imgBox = item.querySelector('.ct-deal-item__img-box');
        if (data.image) {
          if (imgEl && imgEl.tagName.toLowerCase() === 'img') {
            imgEl.src = data.image;
            imgEl.alt = data.productTitle || '';
          } else if (imgBox) {
            imgBox.innerHTML = '<img src="' + data.image + '" alt="' + (data.productTitle || '').replace(/"/g, '&quot;') + '" class="ct-deal-item__img js-ct-img-' + gender + '" loading="lazy" />';
          }
        }

        // Price
        var priceEl = item.querySelector('.js-ct-price-' + gender);
        if (priceEl) {
          var priceText = data.priceFormatted ? data.priceFormatted.replace(/<[^>]*>/g, '') : (data.price ? formatMoney(data.price) : '');
          if (priceText) priceEl.textContent = priceText;
        }

        // Compare at price
        var compareEl = item.querySelector('.js-ct-compare-' + gender);
        if (compareEl) {
          if (data.compareAtPrice && data.price && data.compareAtPrice > data.price) {
            var compareText = data.compareAtPriceFormatted
              ? data.compareAtPriceFormatted.replace(/<[^>]*>/g, '')
              : formatMoney(data.compareAtPrice);
            compareEl.textContent = compareText;
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }

        // Option item variant ID attribute
        if (data.variantId) {
          item.setAttribute('data-variant-id', data.variantId);
        }

        // If this gender is currently selected, update the Add button
        if (selectedGender === gender) {
          updateAddButton(root, data);
        }
      });
    }

    /**
     * Update the Add button state and text
     */
    function updateAddButton(root, prodData) {
      if (!root) return;
      var addBtn = root.querySelector('.js-ct-add-btn');
      if (!addBtn) return;

      var btnText = addBtn.querySelector('.js-ct-btn-text');
      var defaultText = configData.ctaDefaultText || 'Add to Cart';

      if (!prodData) {
        addBtn.setAttribute('disabled', 'disabled');
        addBtn.setAttribute('aria-disabled', 'true');
        if (btnText) btnText.textContent = defaultText;
        return;
      }

      if (prodData.variantId) {
        addBtn.setAttribute('data-variant-id', prodData.variantId);
      }

      if (prodData.available === false) {
        addBtn.setAttribute('disabled', 'disabled');
        addBtn.setAttribute('aria-disabled', 'true');
        if (btnText) btnText.textContent = 'Out of Stock';
      } else if (!isSubmitting) {
        addBtn.removeAttribute('disabled');
        addBtn.setAttribute('aria-disabled', 'false');
        if (btnText) btnText.textContent = defaultText;
      }
    }

    /**
     * Dynamically fetch live product data from Shopify AJAX API
     */
    function fetchProductData(gender) {
      var data = configData[gender];
      if (!data || !data.handle) return;

      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var url = rootPath + 'products/' + encodeURIComponent(data.handle) + '.js';

      fetch(url)
        .then(function (res) {
          if (!res.ok) throw new Error('Product fetch error: ' + res.status);
          return res.json();
        })
        .then(function (product) {
          if (!product || !product.variants || !product.variants.length) return;

          data.productId = product.id;
          data.productTitle = product.title;

          var targetVariant = null;
          var configuredVarId = data.configuredVariantId ? String(data.configuredVariantId).trim() : '';

          // 1. If specific variant ID configured, find it
          if (configuredVarId) {
            targetVariant = product.variants.find(function (v) {
              return String(v.id) === configuredVarId;
            });
          }

          // 2. If Variant ID field is empty or not found, automatically use first available variant
          if (!targetVariant) {
            targetVariant = product.variants.find(function (v) {
              return v.available;
            }) || product.variants[0];
          }

          if (targetVariant) {
            data.variantId = targetVariant.id;
            data.variantTitle = targetVariant.title;
            data.price = targetVariant.price;
            data.priceFormatted = formatMoney(targetVariant.price);
            data.compareAtPrice = targetVariant.compare_at_price || 0;
            data.compareAtPriceFormatted = targetVariant.compare_at_price ? formatMoney(targetVariant.compare_at_price) : '';
            data.available = targetVariant.available;

            var imgUrl = (targetVariant.featured_image && targetVariant.featured_image.src)
              ? targetVariant.featured_image.src
              : (product.featured_image || data.image);
            if (imgUrl) {
              data.image = imgUrl;
            }
          }

          // Update DOM across all instances
          updateProductDOM(gender);

          if (currentCartState) {
            evaluateCart(currentCartState);
          }
        })
        .catch(function () {
          // Graceful fallback to Liquid data
        });
    }

    /**
     * Select gender option (Male or Female) within the single deal
     */
    function selectOption(gender) {
      if (!gender || (gender !== 'male' && gender !== 'female')) {
        gender = 'male';
      }
      selectedGender = gender;
      try {
        sessionStorage.setItem('ct_selected_gender', gender);
      } catch (e) { }

      var prodData = configData[gender];

      var roots = document.querySelectorAll('[data-ct-offer-root]');
      roots.forEach(function (root) {
        root.setAttribute('data-selected-gender', gender);

        // Update Option radio cards
        var items = root.querySelectorAll('.js-ct-deal-item');
        items.forEach(function (item) {
          var itemGender = item.getAttribute('data-ct-gender');
          if (itemGender === gender) {
            item.classList.add('ct-deal-item--selected');
            item.setAttribute('aria-checked', 'true');
          } else {
            item.classList.remove('ct-deal-item--selected');
            item.setAttribute('aria-checked', 'false');
          }
        });

        // Update the Add button target
        updateAddButton(root, prodData);
      });
    }

    /**
     * Show or hide all offer section roots
     */
    function setOfferVisibility(show) {
      var roots = document.querySelectorAll('[data-ct-offer-root]');
      roots.forEach(function (root) {
        if (show) {
          root.classList.remove('ct-deal--hidden');
          root.style.display = '';
        } else {
          root.classList.add('ct-deal--hidden');
          root.style.display = 'none';
        }
      });
    }

    /**
     * Reset eligibility when cart is emptied or cleared
     */
    function resetEligibility() {
      try {
        sessionStorage.removeItem('ct_deal_dismissed');
      } catch (e) { }
      wasOfferInCart = false;
      setOfferVisibility(false);
    }

    /**
     * Automatically remove the offer product(s) from the cart when qualifying threshold is not met
     */
    function removeOfferFromCart(offerItems, cart) {
      if (isAutoRemovingOffer) return;
      if (!offerItems || !offerItems.length) return;

      isAutoRemovingOffer = true;

      // Immediate visual feedback on drawer line items
      offerItems.forEach(function (item) {
        var key = item.key;
        if (key) {
          var removeBtn = document.querySelector('[data-item-key="' + key + '"]');
          var lineItem = removeBtn ? removeBtn.closest('.cart-drawer__item, .ajax-cart__cart-item') : null;
          if (lineItem) {
            lineItem.classList.add('cart-drawer__item--removing');
            lineItem.style.opacity = '0.35';
            lineItem.style.pointerEvents = 'none';
          }
        }
      });

      var updates = {};
      offerItems.forEach(function (item) {
        var key = item.key || (item.variant_id ? String(item.variant_id) : (item.id ? String(item.id) : null));
        if (key) {
          updates[key] = 0;
        }
      });

      if (Object.keys(updates).length === 0) {
        isAutoRemovingOffer = false;
        return;
      }

      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var updateUrl = rootPath + 'cart/update.js';

      fetch(updateUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Auto-remove deal update error: ' + res.status);
          return res.json();
        })
        .then(function (updatedCart) {
          isAutoRemovingOffer = false;
          wasOfferInCart = false;

          setOfferVisibility(false);

          var config = {};
          var configEl = document.getElementById('cart-config');
          if (configEl) {
            try {
              config = JSON.parse(configEl.innerHTML || '{}');
            } catch (e) { }
          }

          if (window.Shopify && window.Shopify.theme && window.Shopify.theme.ajaxCart) {
            window.Shopify.theme.ajaxCart._isRemoving = false;

            if (typeof window.Shopify.theme.ajaxCart.updateTotalsDom === 'function') {
              window.Shopify.theme.ajaxCart.updateTotalsDom(updatedCart, config);
            }

            if (typeof window.Shopify.theme.ajaxCart.updateView === 'function') {
              window.Shopify.theme.ajaxCart.updateView(config, updatedCart).then(function () {
                bindOfferEvents();
                evaluateCart(updatedCart);
              });
            } else {
              bindOfferEvents();
              evaluateCart(updatedCart);
            }

            if (updatedCart.item_count > 0 && typeof window.Shopify.theme.ajaxCart.showCartError === 'function') {
              window.Shopify.theme.ajaxCart.showCartError('Special deal removed: Requires a minimum order value of ' + formatMoney(threshold) + '.');
            }
          } else {
            bindOfferEvents();
            evaluateCart(updatedCart);
          }

          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: updatedCart } }));
          if (window.Events && typeof window.Events.trigger === 'function') {
            window.Events.trigger('cart:ready', updatedCart);
          }
        })
        .catch(function (err) {
          isAutoRemovingOffer = false;
          console.error('Error auto-removing offer product:', err);
        });
    }

    /**
     * Evaluate the current cart state and manage single deal visibility & qualification
     */
    function evaluateCart(cart) {
      if (!cart) return;

      currentCartState = cart;

      var itemCount = typeof cart.item_count === 'number'
        ? cart.item_count
        : (cart.items ? cart.items.length : 0);

      // 1. If cart is empty, completely reset eligibility & hide offer
      if (itemCount === 0 || !cart.items || cart.items.length === 0) {
        resetEligibility();
        return;
      }

      var offerItems = getOfferItemsInCart(cart);
      var hasOffer = offerItems.length > 0;
      var qualifyingSubtotal = getQualifyingSubtotal(cart);

      // 2. If the offer product was in cart and now removed, re-evaluate
      if (wasOfferInCart && !hasOffer) {
        try {
          sessionStorage.removeItem('ct_deal_dismissed');
        } catch (e) { }
      }
      wasOfferInCart = hasOffer;

      // 3. If customer already has the reward product in the cart:
      if (hasOffer) {
        // Validate qualification: does qualifying cart value (excluding the reward) meet threshold?
        if (qualifyingSubtotal < threshold) {
          // Subtotal dropped below threshold -> REMOVE the mystery box from cart!
          setOfferVisibility(false);
          removeOfferFromCart(offerItems, cart);
          return;
        }

        // Cart still qualifies (qualifyingSubtotal >= threshold) and offer is already in cart -> hide deal selector
        setOfferVisibility(false);
        return;
      }

      // 4. Offer product is NOT in cart:
      // If qualifying cart subtotal is below threshold, hide deal selector
      if (qualifyingSubtotal < threshold) {
        setOfferVisibility(false);
        return;
      }

      // 5. Qualifying cart subtotal meets or exceeds threshold AND offer is not in cart -> SHOW SINGLE DEAL!
      setOfferVisibility(true);

      // Update DOM with latest data
      updateProductDOM('male');
      updateProductDOM('female');

      // Ensure the latest selected product remains selected across cart re-renders
      selectOption(selectedGender);
    }

    /**
     * Add the currently selected product/variant to cart via Shopify Cart API
     */
    function handleAddToCart(btnElement) {
      if (isSubmitting) return;

      var root = btnElement ? btnElement.closest('[data-ct-offer-root]') : document.querySelector('[data-ct-offer-root]');
      var currentGender = (root && root.getAttribute('data-selected-gender')) || selectedGender || 'male';
      selectedGender = currentGender;

      var prodData = configData[selectedGender];
      var variantId = prodData && prodData.variantId ? parseInt(prodData.variantId, 10) : 0;
      if (!variantId && btnElement && btnElement.getAttribute('data-variant-id')) {
        variantId = parseInt(btnElement.getAttribute('data-variant-id'), 10);
      }
      if (!variantId && root) {
        var selectedItem = root.querySelector('.ct-deal-item--selected[data-variant-id], [aria-checked="true"][data-variant-id], .js-ct-deal-item[data-ct-gender="' + selectedGender + '"][data-variant-id]');
        if (selectedItem && selectedItem.getAttribute('data-variant-id')) {
          variantId = parseInt(selectedItem.getAttribute('data-variant-id'), 10);
        }
      }

      if (!variantId) {
        if (prodData && prodData.available === false) return;
        return;
      }

      isSubmitting = true;
      if (btnElement) {
        btnElement.setAttribute('disabled', 'disabled');
        btnElement.classList.add('ct-deal-add-btn--loading');
      }

      // Hide any prior feedback
      var feedbacks = document.querySelectorAll('.js-ct-feedback');
      feedbacks.forEach(function (f) { f.style.display = 'none'; });

      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var addUrl = rootPath + 'cart/add.js';

      fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (err) {
              throw err;
            });
          }
          return res.json();
        })
        .then(function () {
          if (btnElement) {
            btnElement.classList.remove('ct-deal-add-btn--loading');
            btnElement.classList.add('ct-deal-add-btn--success');
            var btnText = btnElement.querySelector('.js-ct-btn-text');
            if (btnText) btnText.textContent = '✓ Added to Cart!';
          }

          setTimeout(function () {
            isSubmitting = false;
            // Dynamically refresh Cart Drawer and Cart Page
            refreshCart();
          }, 450);
        })
        .catch(function (err) {
          console.error('Error adding deal product to cart:', err);
          isSubmitting = false;
          if (btnElement) {
            btnElement.classList.remove('ct-deal-add-btn--loading');
            btnElement.removeAttribute('disabled');
          }

          var msg = (err && (err.description || err.message))
            ? (err.description || err.message)
            : 'Could not add product to cart. Please try again.';

          var feedbacks = document.querySelectorAll('.js-ct-feedback');
          feedbacks.forEach(function (f) {
            f.textContent = msg;
            f.style.display = 'block';
          });
        });
    }

    /**
     * Refresh the theme Cart Drawer and Cart Page via ajaxCart
     */
    function refreshCart() {
      var config = {};
      var configEl = document.getElementById('cart-config');
      if (configEl) {
        try {
          config = JSON.parse(configEl.innerHTML || '{}');
        } catch (e) { }
      }

      if (window.Shopify && window.Shopify.theme && window.Shopify.theme.cart) {
        window.Shopify.theme.cart.getCart().then(function (cart) {
          if (window.Shopify.theme.ajaxCart && window.Shopify.theme.ajaxCart.updateView) {
            window.Shopify.theme.ajaxCart.updateView(config, cart).then(function () {
              if (window.Shopify.theme.ajaxCart.showDrawer) {
                window.Shopify.theme.ajaxCart.showDrawer(config);
              }
              bindOfferEvents();
              evaluateCart(cart);
            });
          } else {
            bindOfferEvents();
            evaluateCart(cart);
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        }).catch(function () {
          syncCart();
        });
      } else {
        // Fallback fetch
        var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(rootPath + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            evaluateCart(cart);
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          });
      }
    }

    /**
     * Fetch current cart data and evaluate
     */
    function syncCart() {
      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(rootPath + 'cart.js')
        .then(function (res) {
          if (!res.ok) throw new Error('Cart fetch error');
          return res.json();
        })
        .then(function (cart) {
          evaluateCart(cart);
        })
        .catch(function () { });
    }

    /**
     * Bind DOM events to option selection cards and the single Add button
     */
    function bindOfferEvents() {
      var roots = document.querySelectorAll('[data-ct-offer-root]');
      roots.forEach(function (root) {
        if (root._ctBound) return;
        root._ctBound = true;

        // Selection Cards
        var items = root.querySelectorAll('.js-ct-deal-item');
        items.forEach(function (item) {
          item.addEventListener('click', function (e) {
            e.preventDefault();
            var gender = item.getAttribute('data-ct-gender');
            if (gender) selectOption(gender);
          });

          // Keyboard support (Enter / Space)
          item.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              var gender = item.getAttribute('data-ct-gender');
              if (gender) selectOption(gender);
            }
          });
        });

        // The Add Button
        var addBtn = root.querySelector('.js-ct-add-btn');
        if (addBtn) {
          addBtn.addEventListener('click', function (e) {
            e.preventDefault();
            handleAddToCart(addBtn);
          });
        }
      });

      // Synchronize all roots with current selected gender state
      selectOption(selectedGender);
    }

    // Document level fallback delegation for dynamically rendered DOM
    document.addEventListener('click', function (e) {
      var dealItem = e.target.closest('.js-ct-deal-item');
      if (dealItem) {
        var gender = dealItem.getAttribute('data-ct-gender');
        if (gender) selectOption(gender);
        return;
      }

      var addBtn = e.target.closest('.js-ct-add-btn');
      if (addBtn && !e.defaultPrevented && !isSubmitting) {
        handleAddToCart(addBtn);
      }
    });

    // Hook into theme.js ajaxCart.updateView
    function hookAjaxCart() {
      if (window.Shopify && window.Shopify.theme && window.Shopify.theme.ajaxCart) {
        var originalUpdateView = window.Shopify.theme.ajaxCart.updateView;
        if (originalUpdateView && !originalUpdateView._ctHooked) {
          window.Shopify.theme.ajaxCart.updateView = function (config, Cart) {
            var result = originalUpdateView.apply(this, arguments);
            if (result && typeof result.then === 'function') {
              result.then(function () {
                bindOfferEvents();
                if (Cart) {
                  evaluateCart(Cart);
                } else {
                  syncCart();
                }
              });
            } else {
              bindOfferEvents();
              if (Cart) {
                evaluateCart(Cart);
              } else {
                syncCart();
              }
            }
            return result;
          };
          window.Shopify.theme.ajaxCart.updateView._ctHooked = true;
        }
      }
    }

    hookAjaxCart();
    setTimeout(hookAjaxCart, 500);
    setTimeout(hookAjaxCart, 1500);

    // Listen for theme cart clear event
    if (window.Events && window.Events.on) {
      window.Events.on('cart:clear', function () {
        resetEligibility();
      });
    }

    // Intercept standard fetch calls to cart endpoints
    if (window.fetch) {
      var nativeFetch = window.fetch;
      window.fetch = function () {
        var url = arguments[0];
        var isCartUrl = typeof url === 'string' && (
          url.indexOf('/cart/add') !== -1 ||
          url.indexOf('/cart/change') !== -1 ||
          url.indexOf('/cart/update') !== -1 ||
          url.indexOf('/cart/clear') !== -1
        );

        var fetchPromise = nativeFetch.apply(this, arguments);

        if (isCartUrl) {
          fetchPromise.then(function (res) {
            if (res && res.clone) {
              res.clone().json().then(function (data) {
                bindOfferEvents();
                if (data && typeof data.item_count !== 'undefined') {
                  evaluateCart(data);
                } else {
                  syncCart();
                }
              }).catch(function () {
                syncCart();
              });
            }
          }).catch(function () { });
        }

        return fetchPromise;
      };
    }

    // Intercept XMLHttpRequest for cart endpoints
    if (window.XMLHttpRequest) {
      var origOpen = XMLHttpRequest.prototype.open;
      var origSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) {
        this._ctUrl = url;
        return origOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function () {
        if (this._ctUrl && typeof this._ctUrl === 'string' && this._ctUrl.indexOf('/cart') !== -1) {
          this.addEventListener('load', function () {
            try {
              var response = JSON.parse(this.responseText);
              bindOfferEvents();
              if (response && typeof response.item_count !== 'undefined') {
                evaluateCart(response);
              } else {
                syncCart();
              }
            } catch (e) {
              syncCart();
            }
          });
        }
        return origSend.apply(this, arguments);
      };
    }

    // Listen to custom cart events
    document.addEventListener('cart:updated', function (e) {
      bindOfferEvents();
      if (e.detail && e.detail.cart) {
        evaluateCart(e.detail.cart);
      } else {
        syncCart();
      }
    });

    document.addEventListener('cart:cleared', function () {
      resetEligibility();
    });

    // Theme Editor design mode integration
    document.addEventListener('shopify:section:select', function () {
      bindOfferEvents();
      setOfferVisibility(true);
    });

    // Initial setup
    bindOfferEvents();
    selectOption(selectedGender);
    updateProductDOM('male');
    updateProductDOM('female');
    fetchProductData('male');
    fetchProductData('female');

    // Initial check on load
    syncCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartOfferSection);
  } else {
    initCartOfferSection();
  }
})();
